export default __webpack_public_path__ + "static/media/h5-case-banner.a04b32a9.png";